import {
  CartesianGrid, Line, LineChart, ReferenceLine, Tooltip, XAxis, YAxis,
} from 'recharts'
import type { MikrotikTempThresholds } from '@/lib/mikrotik'

const COLORS = [
  'hsl(var(--primary))',
  'hsl(38 92% 50%)',
  'hsl(142 71% 45%)',
  'hsl(199 89% 48%)',
  'hsl(271 81% 56%)',
  'hsl(var(--muted-foreground))',
]

export function SfpTempChart({
  pivot,
  thresholds,
  axisTick,
  tooltipStyle,
  tsLabel,
}: {
  pivot: { rows: Record<string, unknown>[]; keys: string[] }
  thresholds: MikrotikTempThresholds
  axisTick: object
  tooltipStyle: object
  tsLabel: (v: unknown) => string
}) {
  const { rows, keys } = pivot
  return (
    <LineChart data={rows} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
      <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
      <XAxis dataKey="b" tick={axisTick} tickFormatter={tsLabel}
        stroke="hsl(var(--muted-foreground))" />
      <YAxis tick={axisTick} tickFormatter={(v) => `${v} °C`}
        stroke="hsl(var(--muted-foreground))" width={55} domain={['auto', 'auto']} />
      <Tooltip contentStyle={tooltipStyle} labelFormatter={tsLabel} />
      <ReferenceLine y={thresholds.warn_c} stroke="hsl(38 92% 50%)" strokeDasharray="6 4"
        label={{ value: `warn ${thresholds.warn_c} °C`, fontSize: 10, fill: 'hsl(38 92% 50%)' }} />
      <ReferenceLine y={thresholds.crit_c} stroke="hsl(var(--destructive))" strokeDasharray="6 4"
        label={{ value: `crit ${thresholds.crit_c} °C`, fontSize: 10, fill: 'hsl(var(--destructive))' }} />
      {keys.map((k, i) => (
        <Line key={k} type="monotone" dataKey={k} name={k}
          stroke={COLORS[i % COLORS.length]} dot={false}
          strokeWidth={k.endsWith('carte') ? 1 : 1.5}
          strokeDasharray={k.endsWith('carte') ? '2 4' : undefined} connectNulls />
      ))}
    </LineChart>
  )
}
